// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: packages/content/src/strings/*.ts
import m0 from './strings/auth';
import m1 from './strings/brain';
import m2 from './strings/chat';
import m3 from './strings/common';
import m4 from './strings/creator';
import m5 from './strings/curator';
import m6 from './strings/decor';
import m7 from './strings/email';
import m8 from './strings/emotes';
import m9 from './strings/errors';
import m10 from './strings/fish';
import m11 from './strings/fishing';
import m12 from './strings/fossils';
import m13 from './strings/fullscreen';
import m14 from './strings/furniture';
import m15 from './strings/house';
import m16 from './strings/hud';
import m17 from './strings/install';
import m18 from './strings/items';
import m19 from './strings/letters';
import m20 from './strings/look';
import m21 from './strings/mail';
import m22 from './strings/museum';
import m23 from './strings/nature';
import m24 from './strings/news';
import m25 from './strings/push';
import m26 from './strings/reject';
import m27 from './strings/safety';
import m28 from './strings/settings';
import m29 from './strings/shop';
import m30 from './strings/surfaces';
import m31 from './strings/time';
import m32 from './strings/title';
import m33 from './strings/towns';
import m34 from './strings/tutorial';
import m35 from './strings/villagers';
import m36 from './strings/world';
export const stringModules = { auth: m0, brain: m1, chat: m2, common: m3, creator: m4, curator: m5, decor: m6, email: m7, emotes: m8, errors: m9, fish: m10, fishing: m11, fossils: m12, fullscreen: m13, furniture: m14, house: m15, hud: m16, install: m17, items: m18, letters: m19, look: m20, mail: m21, museum: m22, nature: m23, news: m24, push: m25, reject: m26, safety: m27, settings: m28, shop: m29, surfaces: m30, time: m31, title: m32, towns: m33, tutorial: m34, villagers: m35, world: m36 } as const;
